/**
 * KeyboardHelp - Modal showing keyboard shortcuts
 */

import { useEffect } from 'react';
import './ui/ui.css';

interface KeyboardHelpProps {
  isOpen: boolean;
  onClose: () => void;
}

const shortcuts = [
  { keys: ['W', 'A', 'S', 'D'], action: 'Mover camara' },
  { keys: ['↑', '←', '↓', '→'], action: 'Mover camara' },
  { keys: ['+', '-'], action: 'Zoom' },
  { keys: ['F'], action: 'Seguir criatura seleccionada' },
  { keys: ['Esc'], action: 'Deseleccionar criatura' },
  { keys: ['?'], action: 'Mostrar/ocultar ayuda' },
];

export function KeyboardHelp({ isOpen, onClose }: KeyboardHelpProps) {
  // Close on Escape
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="keyboard-help-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="keyboard-help-title"
    >
      <div className="keyboard-help-modal" onClick={(e) => e.stopPropagation()}>
        <h2 id="keyboard-help-title">Atajos de Teclado</h2>

        <table className="keyboard-help-table">
          <tbody>
            {shortcuts.map((shortcut, index) => (
              <tr key={index}>
                <td className="keys-cell">
                  {shortcut.keys.map((key, i) => (
                    <span key={i}>
                      <kbd className="kbd">{key}</kbd>
                      {i < shortcut.keys.length - 1 && ' / '}
                    </span>
                  ))}
                </td>
                <td className="action-cell">{shortcut.action}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p className="keyboard-help-hint">
          Presiona <kbd className="kbd">Esc</kbd> o haz click fuera para cerrar
        </p>

        <button className="keyboard-help-close" onClick={onClose} aria-label="Cerrar ayuda">
          Cerrar
        </button>
      </div>
    </div>
  );
}
